// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-spinner{animation:loading-spinner 1s linear infinite;border-color:hsla(0,0%,100%,.2) hsla(0,0%,100%,.2) hsla(0,0%,100%,.2) #fff;border-radius:9999px;border-width:2px;line-height:1;top:0;transform:translateZ(0)}@keyframes loading-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
